import { api_link } from "siteConfig";
import axios from "axios";
import { SHA256 } from "crypto-js";

export const updateUserHandler = async (id, email, firstName, lastName, password) => {

    let passed = false

    let fullname = firstName + ' ' + lastName
    let salt = 'V8e0BZFb)QUR';
    let encryption = password ? SHA256(password + salt).toString() : null;
    let url = 'https://'+api_link+'customer_portal_v2/updateuser'

    await axios({
        method: "post",
        url: url,
        data: {
            "referurl": url,
            "var1": email,
            "var2": encryption,
            "var3": id,
            "var4": fullname
        },
        timeout: 5000,
        headers: {
            "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
            // "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json"
        }
    }).then(resp => {
            passed = true
    }).catch(err => {
        
    })
        
    return passed
}